/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Resource/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChairFilled from 'DesignSystem/Svgs/Tysiav2ChairFilled/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Resource({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Resource"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let resourceNameValueData = fromData.useDataValue({ viewPath,
context: 'resource',
path: 'name',
})
let resourceAllocationsValueData = fromData.useDataFormat({ viewPath,
context: 'resource',
path: 'allocations',
format: fromHelpers.getProviders,
})
let resourceAllocationsValueData1 = fromData.useDataFormat({ viewPath,
context: 'resource',
path: 'allocations',
format: fromHelpers.getAssistants,
})
  return (<React.Fragment
>
<div
  data-testid="Resource.Horizontal"
  data-view-path={viewPath}
 style={{'--pr-2-ZjWNCC': isMedia.mobile ? typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-1-ZjWNCC': isMedia.mobile ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2ChairFilled
  viewPath={`${viewPath}/Tysiav2ChairFilled`}
 fill2={dtColorsNeutral400}
 marginRight={dtSpaceXs}
 marginTop={dtSpaceXxs}
/>
<div
  data-testid="Resource.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="resource.name"
 text={resourceNameValueData}
 weight="medium"
 size="normal"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="resource.allocations"
 format="helpers.js getProviders"
 text={resourceAllocationsValueData}
 size="small"
 weight="regular"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="resource.allocations"
 format="helpers.js getAssistants"
 text={resourceAllocationsValueData1}
 color={dtColorsNeutral400}
 size="small"
 weight="regular"
/>
</div>
</div>
{children}
</React.Fragment>)
}